import { jsx } from '@emotion/react';

import { connectFavorites } from './Favorites/FavoritesConnectors';
import { FeatureImage } from './feature_utils';
import { ENABLED_FEATURE_FLAGS } from './features';
import { altText } from './imageAlts';
import { OCNameFilter } from '../../Utilities';
import { connectLocation } from '../../location/LocationConnectors';

const RecentColor = connectFavorites(
  ({ recentView, address, favorites, addToFavorites, removeFromFavorites, locale }) => {
    const favorite = favorites.includes(recentView.uuid);
    const onToggleFavorite = favorite ? removeFromFavorites : addToFavorites;

    return (
      <div className="favorite-tile recently-viewed">
        <div className="favorite-feature">
          <FeatureImage
            address={address}
            item={recentView}
            className="favorites"
            featuresSubset={ENABLED_FEATURE_FLAGS}
          />
          <a href={`/roofing/shingles/${recentView.shingle.uid}?color=${recentView.uid}`}>
            <img
              src={recentView.house_cropped_768x768_url2}
              alt={altText(
                recentView,
                'house_thumb',
                locale.code,
                `${recentView.name} ${recentView.shingle.proper_name}`
              )}
            />
          </a>

          <label className="recent-heart" tabIndex="0">
            <input
              type="checkbox"
              className="recent-favorite-checkbox"
              checked={favorite}
              data-track={favorite ? 'remove-favorite' : 'make-favorite'}
              data-track-product-name={recentView.shingle.uid}
              onChange={() => onToggleFavorite(recentView.uuid)}
            />
            <i className="fa" aria-hidden="true" />
          </label>
        </div>
        <div className="recent-details">
          <OCNameFilter element="div" className="recent-color-name">
            {recentView.shingle.proper_name}
          </OCNameFilter>
          <div className="recent-name">{recentView.name}</div>
        </div>
      </div>
    );
  }
);

export default connectLocation(RecentColor);
